import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frame"];

  load(event) {
    if (event.newState !== "open") return;

    this.frameTarget.reload();
  }

  submitted(event) {
    if (event.detail.success) {
      this.element.hidePopover();
    }
  }
}
